import { render, staticRenderFns } from "./dealer_contact.vue?vue&type=template&id=c8b90b72&"
import script from "./dealer_contact.vue?vue&type=script&lang=js&"
export * from "./dealer_contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports